/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Fuzzy_Weasel_BeamInputs */

const fr_warm_fuzzy_weasel_beam = /** @type {(inputs: Warm_Fuzzy_Weasel_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

/**

* @param {Warm_Fuzzy_Weasel_BeamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const warm_fuzzy_weasel_beam = /** @type {((inputs?: Warm_Fuzzy_Weasel_BeamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Fuzzy_Weasel_BeamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_warm_fuzzy_weasel_beam(inputs)
});